import React, { useState } from 'react';
import { Section } from './ui/Section';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
function FAQCard({
  question,
  answer,
  isOpen,
  onClick,
  index
}: {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
  index: number;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay: index * 0.1
  }} className={`rounded-lg border transition-all duration-300 overflow-hidden ${isOpen ? 'bg-dark-800 border-gold-500 shadow-lg shadow-gold-900/10' : 'bg-dark-800/50 border-dark-700 hover:border-gold-500/30'}`} data-id="element-33">
      <button onClick={onClick} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-34">
        <span className={`font-serif font-bold text-lg md:text-xl transition-colors ${isOpen ? 'text-gold-400' : 'text-cream-100'}`} data-id="element-35">
          {question}
        </span>
        <ChevronDownIcon className={`w-5 h-5 text-gold-500 transition-transform duration-300 flex-shrink-0 ml-4 ${isOpen ? 'rotate-180' : ''}`} data-id="element-36" />
      </button>

      <AnimatePresence initial={false} data-id="element-37">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-38">
            <div className="px-6 pb-6 text-cream-200 leading-relaxed border-t border-dark-700/50 pt-4" data-id="element-39">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <div className="bg-dark-900 pt-0 md:pt-12 pb-4 md:pb-12" data-id="element-40">
      <Section data-id="element-41">
        <div className="max-w-3xl mx-auto" data-id="element-42">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-serif font-bold text-cream-100 text-center mb-8 md:mb-12" data-id="element-43">
            Preguntas Frecuentes
          </motion.h2>

          <div className="space-y-4" data-id="element-44">
            {/* Pregunta 1 */}
            <FAQCard question="¿Cómo recibo el eBook y el audiolibro?" answer="Después del pago, te llega un email automático con los enlaces de descarga. También aparecen botones de descarga directa en la página de confirmación justo después de tu compra." isOpen={openIndex === 0} onClick={() => toggle(0)} index={0} data-id="element-45" />

            {/* Pregunta 2 */}
            <FAQCard question="¿Dónde encuentro mi descarga si no veo el email?" answer="Primero, revisa tu carpeta de Spam o Promociones. Si no está ahí, recuerda que también puedes descargarlo directamente desde la pantalla de confirmación de compra. Si tienes problemas, escríbenos." isOpen={openIndex === 1} onClick={() => toggle(1)} index={1} data-id="element-46" />

            {/* Pregunta 3 */}
            <FAQCard question="¿En qué formatos viene?" answer="Recibirás dos formatos: El libro en PDF de alta calidad, optimizado para leerse cómodamente en cualquier dispositivo, y el audiolibro completo en formato MP3 para escucharlo donde quieras." isOpen={openIndex === 2} onClick={() => toggle(2)} index={2} data-id="element-47" />

            {/* Pregunta 4 */}
            <FAQCard question="¿Puedo pagar en Bolívares?" answer="El sistema procesa pagos en dólares a través de tarjeta de crédito/débito internacional o PayPal. La conversión la hace tu banco automáticamente." isOpen={openIndex === 3} onClick={() => toggle(3)} index={3} data-id="element-48" />
          </div>
        </div>
      </Section>
    </div>;
}